var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.3 55h-367c-9.6 0-17.5 7.9-17.5 17.5v209.7c.1 57.9 47 104.8 104.9 104.9H291c57.9-.1 104.8-47 104.9-104.9v-87.4h19.7c37.4 0 67.7-30.4 67.7-67.7V90c-.1-19.4-15.7-35-35-35zm0 72.1c0 18.1-14.6 32.8-32.8 32.8h-19.7V90h52.4v37.1zM413.3 422h-367c-9.6 0-17.5 7.9-17.5 17.5S36.7 457 46.3 457h367c9.6 0 17.5-7.9 17.5-17.5s-7.9-17.5-17.5-17.5z"
  })));
}

export default SvgCafe;